export const removeByKey = <TK extends keyof any, TV>(obj: Record<TK, TV>, keysToRemove: TK | TK[]) =>
    Object.keys(obj).map(k => k as TK).reduce((result, key) => (Array.isArray(keysToRemove) ? keysToRemove.includes(key) : key === keysToRemove)
        ? result
        : {...result, [key]: obj[key]}, {} as Record<TK, TV>)
